import { render, staticRenderFns } from "./ChartPhotovoltaic.vue?vue&type=template&id=1720ffe8&scoped=true&"
import script from "./ChartPhotovoltaic.vue?vue&type=script&lang=js&"
export * from "./ChartPhotovoltaic.vue?vue&type=script&lang=js&"
import style0 from "./ChartPhotovoltaic.vue?vue&type=style&index=0&id=1720ffe8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1720ffe8",
  null
  
)

export default component.exports